'use client';

import { useRef, useEffect, useState } from 'react';

let videoTimeout: string | number | NodeJS.Timeout | undefined;

const videoSrc = '/video/landing-showcase.mp4';

interface HeadingProps {
  title?: string;
  subtitle?: string;
  translations?: {
    title: string;
    subtitle: string;
  };
}

export default function Heading({
  title = 'Remove image watermark',
  subtitle = 'Your ultimate AI tool for removing watermarks, logos, and unwanted text: professional results at your fingertips.',
  translations,
}: HeadingProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isClient, setIsClient] = useState(false);

  // 使用translations如果存在
  const displayTitle = translations?.title || title;
  const displaySubtitle = translations?.subtitle || subtitle;

  const handleVideoEnd = () => {
    clearTimeout(videoTimeout);
    if (videoRef.current) {
      videoTimeout = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.play();
        }
      }, 1000); // 暂停1秒
    }
  };

  useEffect(() => {
    // 设置客户端标记，避免 hydration 错误
    setIsClient(true);

    return () => {
      clearTimeout(videoTimeout);
    };
  }, []);

  // 在客户端挂载后尝试自动播放视频
  useEffect(() => {
    if (isClient && videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // 自动播放被阻止时的静默处理
          console.log('Autoplay was prevented:', error);
        });
      }
    }
  }, [isClient]);

  return (
    <section className='section-container'>
      <div className='flex flex-row items-center gap-x-16'>
        <div className='w-full md:w-1/2'>
          <h1 className='font-geist mb-9 text-center text-3xl font-bold leading-[1.11] text-gray-800 md:text-left md:text-7xl'>
            {displayTitle}
          </h1>
          <p className='font-geist text-center text-base font-medium md:text-left md:text-2xl'>
            {displaySubtitle}
          </p>
        </div>
        <video
          ref={videoRef}
          src={videoSrc}
          poster='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/619552e2-1e79-4648-0ae9-41f4cd832000/public'
          className='hidden h-auto w-full rounded-xl object-cover md:block md:w-1/2'
          loop={false}
          muted
          playsInline
          preload='auto'
          onEnded={handleVideoEnd}
        />
      </div>
    </section>
  );
}
